import { SET_DESTINATION_URL } from '../types';

export const test = '';

export const setDestinationURL = (pathname) => ({
    type: SET_DESTINATION_URL,
    payload: pathname,
})